import { useCallback, useLayoutEffect, useState } from 'react';

const EDGE = 8;

/**
 * Горизонтальная лента чипов: флаги «есть что листать» по краям,
 * колесо мыши листает вбок (пока есть куда — дальше скроллится страница),
 * scrollStep(±1) для стрелок на десктопе. ref — колбэк: лента может появиться позже.
 */
export function useHScroll() {
  const [el, setEl] = useState(null);
  const [edges, setEdges] = useState({ start: false, end: false });

  useLayoutEffect(() => {
    if (!el) return undefined;
    const sync = () => {
      const max = el.scrollWidth - el.clientWidth;
      setEdges({ start: el.scrollLeft > EDGE, end: el.scrollLeft < max - EDGE });
    };
    const onWheel = (e) => {
      if (e.ctrlKey || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 0) return;
      const canScroll = e.deltaY > 0 ? el.scrollLeft < max - 1 : el.scrollLeft > 1;
      if (!canScroll) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };
    sync();
    el.addEventListener('scroll', sync, { passive: true });
    el.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', sync);
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(sync) : null;
    ro?.observe(el);
    return () => {
      el.removeEventListener('scroll', sync);
      el.removeEventListener('wheel', onWheel);
      window.removeEventListener('resize', sync);
      ro?.disconnect();
    };
  }, [el]);

  const scrollStep = useCallback(
    (dir) => {
      if (!el) return;
      el.scrollBy({ left: dir * Math.max(120, el.clientWidth * 0.7), behavior: 'smooth' });
    },
    [el],
  );

  return { ref: setEl, edges, scrollStep };
}
